import { render } from "./EmployeeCard.vue?vue&type=template&id=5779c080&scoped=true&bindings={}"
import script from "./EmployeeCard.vue?vue&type=script&lang=ts"
export * from "./EmployeeCard.vue?vue&type=script&lang=ts"

import "./EmployeeCard.vue?vue&type=style&index=0&id=5779c080&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-5779c080"

export default script